import apiClient from './apiClient';

export interface SupplierDto {
  id: string;
  clinicId: string;
  name: string;
  contactPerson: string;
  email: string;
  phone: string;
  address: string;
  status: string;
  createdAt?: string;
  updatedAt?: string;
}

function errMessage(e: unknown): string {
  const ax = e as { response?: { data?: { error?: string; message?: string } } };
  return ax.response?.data?.error || ax.response?.data?.message || (e instanceof Error ? e.message : 'Eroare');
}

export async function fetchSuppliers(clinicId: string): Promise<SupplierDto[]> {
  const res = await apiClient.get(`/suppliers?clinicId=${encodeURIComponent(clinicId)}`);
  if (!res.data?.success) throw new Error(res.data?.error || 'Lista furnizori a esuat');
  return res.data.data?.suppliers ?? [];
}

export async function createSupplier(
  clinicId: string,
  payload: { name: string; contactPerson?: string; email?: string; phone?: string; address?: string; status?: string }
): Promise<SupplierDto> {
  const res = await apiClient.post('/suppliers', { ...payload, clinicId });
  if (!res.data?.success) throw new Error(res.data?.error || 'Creare furnizor esuata');
  return res.data.data?.supplier;
}

export async function updateSupplier(
  id: string,
  clinicId: string,
  payload: Partial<Pick<SupplierDto, 'name' | 'contactPerson' | 'email' | 'phone' | 'address' | 'status'>>
): Promise<SupplierDto> {
  const body: Record<string, unknown> = { clinicId };
  if (payload.name !== undefined) body.name = payload.name;
  if (payload.contactPerson !== undefined) body.contactPerson = payload.contactPerson;
  if (payload.email !== undefined) body.email = payload.email;
  if (payload.phone !== undefined) body.phone = payload.phone;
  if (payload.address !== undefined) body.address = payload.address;
  if (payload.status !== undefined) body.status = payload.status;
  const res = await apiClient.patch(`/suppliers/${id}`, body);
  if (!res.data?.success) throw new Error(res.data?.error || 'Actualizare furnizor esuata');
  return res.data.data?.supplier;
}

export { errMessage as supplierServiceErrorMessage };
